import type { FroalaEditorInstance } from "../types";

export const handleTextAlign = (
  editor: FroalaEditorInstance,
  data: string,
  handleAllSelection: () => boolean,
  refresh: (clearSelection?: boolean) => void,
) => {
  const isAllSelected = handleAllSelection();
  editor.align.apply(data);
  editor.save.save();
  refresh(isAllSelected);
};

export const handleTextDirection = (
  editor: FroalaEditorInstance,
  data: "ltr" | "rtl",
  handleAllSelection: () => boolean,
  refresh: (clearSelection?: boolean) => void,
) => {
  const isAllSelected = handleAllSelection();
  editor.selection.save();
  editor.html.wrap(true, true, true, true);
  editor.selection.restore();

  const elements = editor.selection.blocks();

  editor.selection.save();

  for (let i = 0; i < elements.length; i++) {
    const element: HTMLElement = elements[i];
    if (element.nodeName === "LI")
      element.parentElement?.setAttribute("data-direction", data);
    if (element !== editor.$el.get(0)) {
      editor
        .$(element)
        .css("direction", data)
        .css("text-align", data === "rtl" ? "right" : "left")
        .removeClass("fr-temp-div");
    }
  }

  // Unwrap temp divs.
  editor.html.unwrap();

  // Restore selection.
  editor.selection.restore();

  editor.save.save();
  refresh(isAllSelected);
};
